// @flow
import React, { type Element } from 'react'
import MobilePrAnnotationBox from '../boxes/StyledMobilePrAnnotationBox'
import SpirMonWrapperWithoutImpression from '../widgets/Advert/SpirMonWrapperWithoutImpression'
import { type BoxType as Box } from '../Types'
import Prannotation from './Prannotation'

const Ad = props => {
  const {
    commentBottom,
    commentTop,
    id: guid,
    image: {
      default: {
        url: image
      }
    },
    title,
    url: link
  } = props

  return (
    <SpirMonWrapperWithoutImpression commentTop={commentTop} commentBottom={commentBottom}>
      <MobilePrAnnotationBox
        image={image}
        imageClass={`image-4_3`}
        isImage={true}
        key={guid}
        link={link}
        title={title}
      />
    </SpirMonWrapperWithoutImpression>
  )
}

type Props = {|
  ad: Object,
  boxes: Array<Box>,
  device: string,
  name: string,
  renderImageBox: (box: Box, index: number) => Element<*>
|}

export default (props: Props) => {
  const {
    ad,
    boxes,
    device,
    name,
    renderImageBox
  } = props

  return (
    <Prannotation AdComponent={Ad} device={device} id={`ad-${name}`} sashec={ad}>
      {boxes.map(renderImageBox)}
    </Prannotation>
  )
}
